import { motion } from "framer-motion";
import ContactForm from "./ContactForm";


const FormModal = ({ show, closeModal }) => {
    if (!show) return null;

    return (
        <div className="modal d-block" style={{ background: "rgba(0,0,0,0.6)" }}>
            <div className="modal-dialog modal-dialog-centered modal-md">
                <motion.div
                    className="modal-content border-0 overflow-hidden"
                    initial={{ scale: 0.85, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                >
                    <div className="bg-maroon shadow-lg rounded p-4 p-lg-5 position-relative">

                        {/* ❌ CLOSE BUTTON (TOP RIGHT) */}
                        <button
                            type="button"
                            className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                            onClick={closeModal}
                        ></button>

                        {/* HEADER */}
                        <div className="text-center mb-4">
                            <h4 className="fw-bold text-white mb-2">
                                ONE by MSN
                            </h4>
                            <p className="text-white-50 mb-0">
                                Premium plotted development surrounded by nature
                            </p>
                        </div>

                        {/* FORM */}
                        <div className="modal-body p-0">
                            <ContactForm onSuccess={closeModal} />
                        </div>

                        {/* 📞 CALL HIGHLIGHT */}
                        {/* <div className="d-flex align-items-center gap-3 mt-4 p-3 bg-light rounded">
                            <div
                                className="rounded-circle bg-white border d-flex align-items-center justify-content-center"
                                style={{ width: "44px", height: "44px" }}
                            >
                                📞
                            </div>

                            <div>
                                <small className="text-muted">Call for Instant Details</small>
                                <h5 className="fw-bold mb-0">
                                    <a
                                        href="tel:+919652389333"
                                        className="text-decoration-none text-dark"
                                    >
                                        +91 96523 89333
                                    </a>
                                </h5>
                            </div>
                        </div> */}

                    </div>
                </motion.div>
            </div>
        </div>

    );
};

export default FormModal;
